// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p {
  color: white;
}

.img {
  height: 75px;
  width: 75px;
}

.btn {
  text-align: center;
  display: inline-block;
}

.btn button {
  background-color: #262626;
}

.dropdown-toggle::after {
  color: rgb(255, 255, 255);
}`, "",{"version":3,"sources":["webpack://./src/app/features/ada-access/shared/profile/profile.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAGA;EACE,YAAA;EACA,WAAA;AAAF;;AAGA;EACE,kBAAA;EACA,qBAAA;AAAF;;AAGA;EACE,yBAAA;AAAF;;AAGA;EACE,yBAAA;AAAF","sourcesContent":["p {\n  color: white;\n}\n\n\n.img {\n  height: 75px;\n  width: 75px;\n}\n\n.btn {\n  text-align: center;\n  display: inline-block;\n}\n\n.btn button {\n  background-color: #262626;\n}\n\n.dropdown-toggle::after {\n  color: rgb(255, 255, 255);\n}\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
